import { render, staticRenderFns } from "./DokumenAnggotaUmum.vue?vue&type=template&id=2516225a&scoped=true&"
import script from "./DokumenAnggotaUmum.vue?vue&type=script&lang=js&"
export * from "./DokumenAnggotaUmum.vue?vue&type=script&lang=js&"
import style0 from "./DokumenAnggotaUmum.vue?vue&type=style&index=0&id=2516225a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2516225a",
  null
  
)

export default component.exports